import loadable from '@loadable/component'; // needed to lazy load components

export const NotFoundPage = loadable(() => import(/* webpackChunkName: "containers.others" */ './NotFoundPage/NotFoundPage'));
export const StaticPage = loadable(() => import(/* webpackChunkName: "containers.others" */ './StaticPage/StaticPage'));
export { default as TopbarContainer } from './TopbarContainer/TopbarContainer';